import ImgCoffee from '../images/offers/coffee.jpg';
import ImgEvCharging1 from '../images/offers/evCharging-1.jpg';
import ImgEvCharging2 from '../images/offers/evCharging-2.jpg';
import ImgFuel98 from '../images/offers/fuel98.jpg';
import ImgFuelE851 from '../images/offers/fuelE85-1.jpg';
import ImgFuelE852 from '../images/offers/fuelE85-2.jpg';
import ImgPastries from '../images/offers/pastries.jpg';
import * as LotteryPrizes from '../images/lottery-prizes';

export const OffersIllustrationsMap = {
    'illustration-coffee': ImgCoffee,
    'illustration-ev-charging-1': ImgEvCharging1,
    'illustration-ev-charging-2': ImgEvCharging2,
    'illustration-fuel-98': ImgFuel98,
    'illustration-fuel-E85-1': ImgFuelE851,
    'illustration-fuel-E85-2': ImgFuelE852,
    'illustration-pastries': ImgPastries,
    LoosiratasImgBatoonBarbells: LotteryPrizes.LoosiratasImgBatoonBarbells,
    LoosiratasImgBatoonKismet: LotteryPrizes.LoosiratasImgBatoonKismet,
    LoosiratasImgBatoonMars: LotteryPrizes.LoosiratasImgBatoonMars,
    LoosiratasImgBatoonSnickers: LotteryPrizes.LoosiratasImgBatoonSnickers,
    LoosiratasImgBatoonSusu: LotteryPrizes.LoosiratasImgBatoonSusu,
    LoosiratasImgBatoonTupla: LotteryPrizes.LoosiratasImgBatoonTupla,
    LoosiratasImgCoopRahatasku: LotteryPrizes.LoosiratasImgCoopRahatasku,
    LoosiratasImgJookCocafantasprite: LotteryPrizes.LoosiratasImgJookCocafantasprite,
    LoosiratasImgJookForme: LotteryPrizes.LoosiratasImgJookForme,
    LoosiratasImgJookNocco: LotteryPrizes.LoosiratasImgJookNocco,
    LoosiratasImgJookVesi: LotteryPrizes.LoosiratasImgJookVesi,
    LoosiratasImgJaakohv: LotteryPrizes.LoosiratasImgJaakohv,
    LoosiratasImgJaatisTompulga: LotteryPrizes.LoosiratasImgJaatisTompulga,
    LoosiratasImgJaatisTomtopsi: LotteryPrizes.LoosiratasImgJaatisTomtopsi,
    LoosiratasImgOmatootajaHotdog: LotteryPrizes.LoosiratasImgOmatootajaHotdog,
    LoosiratasImgOmatootajaSnickers: LotteryPrizes.LoosiratasImgOmatootajaSnickers,
    LoosiratasImgSaiakesed: LotteryPrizes.LoosiratasImgSaiakesed,
    LoosiratasImgSoetoitBurger: LotteryPrizes.LoosiratasImgSoetoitBurger,
    LoosiratasImgsoetoitFriikartul: LotteryPrizes.LoosiratasImgsoetoitFriikartul,
    LoosiratasImgSoetoitHatsapuri: LotteryPrizes.LoosiratasImgSoetoitHatsapuri,
    LoosiratasImgSoetoitHotdog: LotteryPrizes.LoosiratasImgSoetoitHotdog,
    LoosiratasImgSoetoitKuumjook: LotteryPrizes.LoosiratasImgSoetoitKuumjook,
    LoosiratasImgSoetoitKytus: LotteryPrizes.LoosiratasImgSoetoitKytus,
    LoosiratasImgSoetoitPallid: LotteryPrizes.LoosiratasImgSoetoitPallid,
    LoosiratasImgSoetoitPelmeen: LotteryPrizes.LoosiratasImgSoetoitPelmeen,
    LoosiratasImgSoetoitWrapilla: LotteryPrizes.LoosiratasImgSoetoitWrapilla,
    LoosiratasImgTakupoissburger: LotteryPrizes.LoosiratasImgTakupoissburger,
    LoosiratasImgTakupoissHaugikotlett: LotteryPrizes.LoosiratasImgTakupoissHaugikotlett,
    LoosiratasImgTakupoissKana: LotteryPrizes.LoosiratasImgTakupoissKana,
    LoosiratasImgTakupoissKokteil: LotteryPrizes.LoosiratasImgTakupoissKokteil,
    LoosiratasImgTakupoissLimonaad: LotteryPrizes.LoosiratasImgTakupoissLimonaad,
    LoosiratasImgTakupoissPannkook: LotteryPrizes.LoosiratasImgTakupoissPannkook,
    LoosiratasImgVeeplokk: LotteryPrizes.LoosiratasImgVeeplokk,
};